module.exports = __webpack_public_path__ + "img/21.9e8f95cb.jpg";